import { render, staticRenderFns } from "./supCotStat.vue?vue&type=template&id=32b89cb9&"
import script from "./supCotStat.vue?vue&type=script&lang=js&"
export * from "./supCotStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "supCotStat.vue"
export default component.exports